export enum ValueSyncType {  
  Replace = 0,
  Ignore = 1 
}